import {
  FaHome,
  FaBox,
  FaGem,
  FaUsers,
  FaBullhorn,
  FaImage,
  FaTag,
  FaRing,
  FaCoins,
  FaGem as FaDiamond,
  FaPalette,
  FaLayerGroup,
  FaUser,
  FaPhone,
  FaGift,
} from "react-icons/fa";
import { FcDepartment, FcMoneyTransfer } from "react-icons/fc";
import { NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";

export const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <FaHome />,
  },

  // ---------------- CATALOG ----------------
  {
    name: "Catalog",
    icon: <FaBox />,
    subRoutes: [
    { path: "/products", name: "Products", icon: <FaBox /> },
    { path: "/category", name: "Categories", icon: <FaTag /> },
    { path: "/brands", name: "Brands", icon: <FaTag /> },
  ],
  },

  // ---------------- ATTRIBUTES ----------------
  {
    name: "Attributes",
    icon: <FaGem />,
    subRoutes: [
    { path: "/jeweleryType", name: "Jewellery Type", icon: <FaRing /> },
    { path: "/metalType", name: "Metal Type", icon: <FaCoins /> },
    { path: "/stones", name: "Stone Type", icon: <FaGem /> },
    { path: "/diamonds", name: "Diamond Type", icon: <FaDiamond /> },
    { path: "/color", name: "Color", icon: <FaPalette /> },
    { path: "/material", name: "Material", icon: <FaLayerGroup /> },
  ],
  },

  // ---------------- CUSTOMERS ----------------
  {
    name: "Customers",
    icon: <FaUsers />,
    subRoutes: [
    { path: "/users", name: "Users", icon: <FaUser /> },
    { path: "/userContactList", name: "User Contacts", icon: <FaUsers /> },
    { path: "/product-inquiry", name: "Product Inquiry", icon: <FaPhone /> },
  ],
  },

  // ---------------- MARKETING ----------------
  {
    name: "Marketing",
    icon: <FaBullhorn />,
    subRoutes: [
    { path: "/offers", name: "Offers", icon: <FaImage /> },
    { path: "/grabbed-offers", name: "Grabbed Offers List", icon: <FaImage /> },
  ],
  },

  // ---------------- CONTENT ----------------
  {
    name: "Content",
    icon: <FaImage />,
    subRoutes: [
      { path: "/homePageStory", name: "Home Page Story" },
      { path: "/homePageBanner", name: "Home Banner" },
    ],
  },
];

const SideBar = ({ isOpen }) => {
  return (
    <div className="left-sidebar p-2">

      {routes.map((route, index) => {
        if (route.subRoutes) {
          return (
            <SidebarMenu
              key={index}
              route={route}
              isOpen={isOpen}
            />
          );
        }

        return (
          <NavLink
            to={route.path}
            key={index}
            className="d-flex align-items-center gap-2 p-2 text-decoration-none"
          >
            <span>{route.icon}</span>
            {isOpen && <span>{route.name}</span>}
          </NavLink>
        );
      })}

    </div>
  );
};

export default SideBar;
